import { Division, EmptyState, Icons, Paragraph } from "@ir/ui";

export const ConfigLandingPage = () => (
  <Division className="config-landing">
    <EmptyState
      icon={Icons.Settings}
      title="Select an organization and brand"
      description="Choose an Org/Brand above to view and manage Configuration for that brand."
    />
    <Paragraph className="text-grey-500 text-center mt-2">
      The Configuration submenu becomes available after a brand is selected.
    </Paragraph>
  </Division>
);
